const i18n = {
  state: {
    lang: ''
  },

  mutations: {
    SET_LANG: (state, lang) => {
      state.lang = lang;
    },
  },
  actions: {
    changeLanguage({commit}, lang) {
      commit('SET_LANG', lang);
    }
  }
};

export default i18n;
